/**
 * Section: About & Showcase Portfolio Marquee (custom-about-showcase.js)
 * Smooth continuous infinite marquee with:
 * - Direct image pre-caching
 * - Touch & hover pause handlers
 * - Shopify Theme Editor integration
 */

(function () {
  'use strict';

  function preloadImages(wrapper) {
    var imgs = wrapper.querySelectorAll('.juli-showcase-card-img');
    var seen = {};
    for (var i = 0; i < imgs.length; i++) {
      var src = imgs[i].getAttribute('src') || imgs[i].currentSrc || '';
      if (src && !seen[src]) {
        seen[src] = true;
        var preloader = new Image();
        preloader.src = src;
      }
    }
  }

  function initShowcaseMarquee() {
    var marqueeWrappers = document.querySelectorAll('.juli-showcase-marquee-wrapper');
    if (!marqueeWrappers.length) return;

    marqueeWrappers.forEach(function (wrapper) {
      preloadImages(wrapper);

      wrapper.addEventListener('touchstart', function () {
        wrapper.classList.add('is-paused');
      }, { passive: true });

      wrapper.addEventListener('touchend', function () {
        setTimeout(function () {
          wrapper.classList.remove('is-paused');
        }, 1000);
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShowcaseMarquee);
  } else {
    initShowcaseMarquee();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.juli-showcase-marquee-wrapper')) {
      initShowcaseMarquee();
    }
  });

  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('.juli-showcase-marquee-wrapper')) {
      initShowcaseMarquee();
    }
  });
})();
